export default __webpack_public_path__ + "static/media/DhofarDarkLogo.6ee431ee.png";